import { Link } from "react-router-dom";
import { Download, Hourglass, PackageX } from "lucide-react";
import { absUrl } from "@/lib/api";
import { useI18n } from "@/i18n/I18nContext";
import { useDownload, useDownloadReturn } from "@/components/apps/useDownload";

export const DownloadButton = ({ app, large = false, testId = "download-btn", autoStart = false }) => {
  const { t } = useI18n();
  const { wait, start, fail } = useDownload(absUrl(app.download_url || ""));
  useDownloadReturn(start, fail, autoStart && !!app.active_version);
  if (!app.active_version) {
    return (
      <p
        className="inline-flex items-center gap-2 rounded-full border border-[rgba(208,20,31,0.5)] bg-[rgba(74,6,11,0.5)] px-4 py-2 text-xs font-semibold uppercase tracking-wider text-red-200"
        data-testid="no-version-available"
      >
        <PackageX className="h-4 w-4" /> {t("apps.noVersion")}
      </p>
    );
  }
  return (
    <span className="inline-flex max-w-full flex-wrap items-center gap-2">
    <a
      href={absUrl(app.download_url)}
      download
      onClick={start}
      aria-busy={!!wait}
      className={`btn-gold ${large ? "px-8 py-4 text-sm" : "btn-sm"}`}
      data-testid={testId}
    >
      {wait ? <Hourglass className={`${large ? "h-5 w-5" : "h-4 w-4"} animate-pulse`} /> : <Download className={large ? "h-5 w-5" : "h-4 w-4"} />} {t("apps.download")}
    </a>
    <Link to="/installer-un-apk" title={t("install.help")} aria-label={t("install.help")} data-testid={`${testId}-help`}
      className={`inline-flex shrink-0 items-center justify-center rounded-full border border-[var(--gold)] font-display font-bold text-[var(--gold-bright)] transition-colors duration-200 hover:bg-[rgba(245,197,66,0.15)] ${large ? "h-10 w-10 text-base" : "h-8 w-8 text-sm"}`}>?</Link>
    {wait && (
      <span className="basis-full text-xs font-semibold text-[var(--gold-bright)]" role="status" data-testid={`${testId}-wait`}>
        {t("dl.waiting", { s: Math.max(1, wait.eta_s), n: wait.position })}
      </span>
    )}
    </span>
  );
};
